import Vue from 'vue';
import checklistGroupService from "./index";

// When the request succeeds
const success = (data, context, rental_id) => {
  context.getChecklistGroup(rental_id);
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal("Deleted!", context.$t('rentals.detail.checklists.checklist_deleted'), "success");
  context.loading = false;
};

// When the request fails
const failed = (error, context) => {
    context.showToasterError(error);
};

export default (context, checklistGroup) => {
    return Vue.$http.delete('/check-list-groups/'+checklistGroup.id)
        .then((response) => {
            if (response && response.status === 200) {
                success(response.data, context, checklistGroup.rental_id);
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/checklist_group/destroy.js